<template #content>
    <Dialog
        :visible="visible"
        @update:visible="updateVisible"
        header="Perfil"
        @show="onShow"
        @hide="onHide"
        class="w-11 lg:w-4"
        modal>
        <form @submit.prevent="onSubmit(form)">
            <div class="w-full">
                <div class="field mt-4">
                    <FloatLabel>
                        <InputText id="nome" v-model="form.nome" class="w-full" />
                        <label for="nome">Nome</label>
                    </FloatLabel>
                    <div class="text-xs text-red-500">{{ errors['nome'] }}</div>
                </div>
                <div class="field mt-4">
                    <FloatLabel>
                        <InputText id="login" v-model="form.login" class="w-full" />
                        <label for="login">Login</label>
                    </FloatLabel>
                    <div class="text-xs text-red-500">{{ errors['login'] }}</div>
                </div>
                <div class="field mt-4">
                    <FloatLabel>
                        <InputText id="email" v-model="form.email" class="w-full" />
                        <label for="email">E-mail</label>
                    </FloatLabel>
                    <div class="text-xs text-red-500">{{ errors['email'] }}</div>
                </div>
                <div class="field mt-4">
                    <FloatLabel>
                        <InputText id="telefone" v-model="form.telefone" class="w-full" />
                        <label for="telefone">Telefone</label>
                    </FloatLabel>
                </div>
                <div class="field mt-4">
                    <FloatLabel>
                        <InputText id="whatsapp_numero" v-model="form.whatsapp_numero" class="w-full" placeholder="+5519999999999" />
                        <label for="whatsapp_numero">WhatsApp (E.164)</label>
                    </FloatLabel>
                    <div class="text-xs text-500 mt-1">Necessario para receber avisos de passagem de fase por WhatsApp.</div>
                </div>

                <Divider />

                <div class="text-sm font-semibold mb-2">
                    <i class="pi pi-bell mr-1"></i> Nao receber avisos por:
                </div>
                <div class="flex align-items-center gap-4">
                    <div class="flex align-items-center gap-2">
                        <Checkbox id="optout_email" v-model="form.optout_email" binary />
                        <label for="optout_email">Email</label>
                    </div>
                    <div class="flex align-items-center gap-2">
                        <Checkbox id="optout_whatsapp" v-model="form.optout_whatsapp" binary />
                        <label for="optout_whatsapp">WhatsApp</label>
                    </div>
                </div>
                <div class="text-xs text-500 mt-1">Notificacoes in-app (sino) sempre sao mostradas.</div>
            </div>

            <div class="flex justify-content-end gap-1 mt-3">
                <Button
                    type="submit"
                    label="Salvar"
                    severity="success"
                    icon="pi pi-save"
                    class="flex align-items-center justify-content-center"
                    :loading="isLoading" />
                <Button
                    label="Fechar"
                    severity="warn"
                    icon="pi pi-times"
                    @click="updateVisible(false)"
                    class="flex align-items-center justify-content-center"
                    :loading="isLoading" />
            </div>
        </form>

    </Dialog>
</template>
<script>
import Dialog from 'primevue/dialog';
import FloatLabel from 'primevue/floatlabel';
import InputText from 'primevue/inputtext';
import Password from 'primevue/password';
import Button from 'primevue/button';
import Checkbox from 'primevue/checkbox';
import Divider from 'primevue/divider';

import Auth from '@/service/auth.js';

export default {
    components: {
        Dialog, FloatLabel, Button, InputText, Password, Checkbox, Divider,
    },
    props: {
        visible: { type: Boolean, default: false },
        data:    { type: Object,  default: () => ({}) },
    },
    emits: ['save','close'],
    data() {
        return {
            form: {},
            errors: {},
            isLoading: false,
        };
    },
    methods: {
        onShow() {
            const d = this.data || {};
            const optout = d.notif_canais_optout || {};
            this.form = {
                ...d,
                optout_email:    !!optout.email,
                optout_whatsapp: !!optout.whatsapp,
            };
            this.errors = {};
        },
        onHide() {
            // reset gerenciado por onShow
        },
        updateVisible(visible) {
            this.$emit('close', visible);
        },
        onSubmit(form) {
            this.errors = {};
            this.isLoading = true;
            const payload = {
                nome:            form.nome,
                login:           form.login,
                email:           form.email,
                telefone:        form.telefone,
                whatsapp_numero: form.whatsapp_numero,
                notif_canais_optout: {
                    email:    !!form.optout_email,
                    whatsapp: !!form.optout_whatsapp,
                },
            };
            Auth.profile(payload)
                .then(response => {
                    this.$toast.add({ severity: 'success', summary: 'Sucesso', detail: response.data.msg, life: 3000 });
                    this.$emit('save', response.data.data);
                    this.$emit('close');
                })
                .catch(error => {
                    if (error.response) {
                        const err = error.response.data;
                        if (err.erros) {
                            for (const i in err.erros) {
                                this.errors[i] = err.erros[i][0];
                            }
                            return;
                        }
                        if (err.msg) {
                            this.$toast.add({ severity: 'error', summary: 'Ops!', detail: err.msg, life: 5000 });
                            return;
                        }
                    }
                    this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.message, life: 5000 });
                })
                .finally(() => { this.isLoading = false; });
        },
    },
};
</script>
